import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import Callback from "./Callback";
import reportWebVitals from "./reportWebVitals";
import { AuthProvider } from "react-oidc-context";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";

const getQueryParam = (param) => {
  const urlParams = new URLSearchParams(window.location.search);
  return urlParams.get(param);
};

// Retrieve from query parameters
const tenantDomain = getQueryParam("tenant_domain");
const clientId = getQueryParam("client_id");

// Store values in sessionStorage if available
if (tenantDomain && clientId) {
  sessionStorage.setItem("tenant_domain", tenantDomain);
  sessionStorage.setItem("client_id", clientId);
}

// Retrieve stored values if not present in the query
const storedTenantDomain = sessionStorage.getItem("tenant_domain");
const storedClientId = sessionStorage.getItem("client_id");

if (!storedTenantDomain || !storedClientId) {
  // Show error if both are missing
  const root = ReactDOM.createRoot(document.getElementById("root"));
  root.render(
    <React.StrictMode>
      <div style={{ textAlign: "center", padding: "20px", color: "red" }}>
        <h2>Configuration Error</h2>
        <p>
          Missing required parameters: <strong>tenant_domain</strong> or{" "}
          <strong>client_id</strong>
        </p>
      </div>
    </React.StrictMode>
  );
} else {
  const oidcConfig = {
    authority: `https://${storedTenantDomain}`,
    client_id: storedClientId,
    redirect_uri: `${window.location.origin}/callback`, // Redirect to callback page
    post_logout_redirect_uri: `${window.location.origin}/`,
    onSigninCallback: () => {
      window.history.replaceState({}, document.title, window.location.pathname);
    },
    extraQueryParams: {
      prompt: "login",
    },
  };

  const root = ReactDOM.createRoot(document.getElementById("root"));
  root.render(
    <React.StrictMode>
      <AuthProvider {...oidcConfig}>
        <Router>
          <Routes>
            <Route path="/" element={<App />} />
            <Route path="/callback" element={<Callback />} />
          </Routes>
        </Router>
      </AuthProvider>
    </React.StrictMode>
  );
}

reportWebVitals();
